import Store from 'Services/Store';
import Feature from 'Services/Feature';
import AutomationTemplatesSellsy from 'vcomponents/automation/templates/AutomationTemplatesSellsy.vue';
import AutomationListing from 'vcomponents/automation/listing/AutomationListing.vue';
import AutomationBuilder from 'vcomponents/automation/builder/AutomationBuilder.vue';

const hasFullAccess = (user) => {
    return user.isAdmin || user.permissions?.acl?.manage_automations;
};

const checkAccess = (to, from, next) => {
    const user = Store.get('user');
    const isAuthorized = Feature.isEnabled('automations') && hasFullAccess(user);
    if (isAuthorized) {
        next();
    } else {
        next({ name: 'error.not.found' });
    }
};

const checkAccessTemplates = (to, from, next) => {
    if (Feature.isEnabled('automations')) {
        next();
    } else {
        next({ name: 'error.not.found' });
    }
};

export default [
    {
        path: '/automations',
        redirect: () => {
            const user = Store.get('user');
            return hasFullAccess(user) ? '/automations/listing' : '/automations/templates';
        },
    },
    {
        path: '/automations/listing',
        name: 'automations.listing',
        component: AutomationListing,
        beforeEnter: checkAccess,
    },
    {
        path: '/automations/templates',
        name: 'automations.templates',
        component: AutomationTemplatesSellsy,
        beforeEnter: checkAccessTemplates,
    },
    {
        path: '/automations/templates/:internalId',
        name: 'automations.templates.share',
        component: AutomationTemplatesSellsy,
        beforeEnter: checkAccessTemplates,
    },
    {
        path: '/automations/templates/:internalId',
        name: 'automations.templates.share',
        component: AutomationTemplatesSellsy,
        beforeEnter: checkAccess,
    },
    {
        path: '/automations/builder/:id',
        name: 'automations.flow.builder',
        component: AutomationBuilder,
        beforeEnter: checkAccess,
    },
];
